import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import './index.css';

interface BreadCrumbsProps {
  hasSubMenus?: boolean;
  customNameMap?: Record<string, string>;
}

const BreadCrumbs = ({ hasSubMenus, customNameMap = {} }: BreadCrumbsProps) => {
    const location = useLocation();
    const params = useParams();
    let currentLink: string[] = [];
    
    const crumbs = location.pathname.split('/')
        .filter(crumb => crumb !== '')
        .map((crumb, index, array) => {
            currentLink.push(`/${crumb}`);
            const isFirstCrumbWithSubmenus = index === 0 && hasSubMenus;
            const isCurrentPath = currentLink.join('') === location.pathname;

            // Check if this crumb should be replaced with custom name
            const shouldUseCustomName = customNameMap[crumb] && crumb === params.id;
            
            if (shouldUseCustomName) {
                return (
                    <div className='crumb' key={crumb}>
                        <span className="no-underline">
                            {customNameMap[crumb]}
                        </span>
                    </div>
                );
            }

            // Skip displaying raw IDs in breadcrumbs
            if (crumb === params.id) {
                return null;
            }

            const displayCrumb = decodeURIComponent(crumb.replace(/-/g, ' '))
                .charAt(0).toUpperCase() + 
                decodeURIComponent(crumb.replace(/-/g, ' ')).slice(1);

            return (
                <div className='crumb' key={crumb}>
                    {isFirstCrumbWithSubmenus || isCurrentPath ? (
                        <span className="no-underline">
                            {displayCrumb}
                        </span>
                    ) : (
                        <Link to={currentLink.join('')} className="no-underline">
                            {displayCrumb}
                        </Link>
                    )}
                </div>
            );
        })
        .filter(Boolean); // Remove null entries

    return (
        <div className='breadeCrumbs mt-2'>
            {crumbs}
        </div>
    );
};

export default BreadCrumbs;